<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      Dados do Veículo
    </div>
    <div class="panel-body">
      <form>
        <div class="form-group">
          <label>Nome do Veículo</label>
          <br>
          <small>Verifique se o veículo que você vai sugerir consta na nossa base. Digite o nome e veja se há
            algum correspondente. Você pode enviar novas informações ou dados atualizados sobre o mesmo
            veículo.</small>
          <v-auto-complete
            v-model="media.media"
            :service="suggestionService"
            :is-async="true"
            @input="updateForm"
            @onSetValue="getMediaData"
          />
        </div>
        <div class="form-group">
          <label>Este veículo é exclusivamente um blog, site pessoal ou página pessoal em rede
            social? </label>
          <br>
          <small>Assinale "Sim" apenas para sites e blogs que sejam independentes de grandes grupos de mídia.
            Ex. blogs dentro de grandes jornais são "Não"</small>
          <select
            v-model="media.paid_site"
            class="form-control"
            @change="updatePaidSite"
          >
            <option
              v-for="opt in paidSiteOptions"
              :key="opt.value"
              :value="opt.value"
            >
              {{ opt.text }}
            </option>
          </select>
        </div>
        <div
          v-show="media.paid_site === 1"
          class="platform-native-fields"
        >
          <h4>Informações específicas para blogs, sites pessoais e páginas em redes sociais</h4>
          <p class="help-block">
            Preencha estes campos adicionais apenas quando o veículo indicado for exclusivamente um blog,
            site pessoal ou página pessoal em rede social.
          </p>
          <div class="form-group">
            <label>Ano de início da iniciativa</label>
            <input
              v-model="media.initiative_start_year"
              type="number"
              min="1800"
              class="form-control"
              @input="updateForm"
            >
          </div>
          <div class="form-group">
            <label>Principal tema de cobertura</label>
            <select
              v-model="media.main_coverage_topic"
              class="form-control"
              @change="updateForm"
            >
              <option :value="null">
                Selecione
              </option>
              <option
                v-for="opt in coverageTopics"
                :key="opt.value"
                :value="opt.value"
              >
                {{ opt.text }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Outros temas de cobertura</label>
            <small>Pode marcar mais de uma alternativa</small>
            <v-check-box-group
              v-model="media.other_coverage_topics"
              :options="coverageTopics"
              @input="updateForm"
            />
          </div>
          <div class="form-group">
            <label>Público-alvo</label>
            <v-check-box-group
              v-model="media.target_audiences"
              :options="targetAudiences"
              @input="updateForm"
            />
          </div>
          <div class="form-group">
            <label>Abrangência de cobertura</label>
            <v-check-box-group
              v-model="media.coverage_scopes"
              :options="coverageScopes"
              @input="updateForm"
            />
          </div>
          <div class="form-group">
            <label>Produz conteúdo original?</label>
            <select
              v-model="media.produces_original_content"
              class="form-control"
              @change="updateForm"
            >
              <option :value="null">
                Selecione
              </option>
              <option
                v-for="opt in yesNoOptions"
                :key="opt.value"
                :value="opt.value"
              >
                {{ opt.text }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Plataforma principal</label>
            <select
              v-model="media.primary_platform"
              class="form-control"
              @change="updateForm"
            >
              <option :value="null">
                Selecione
              </option>
              <option
                v-for="opt in platformOptions"
                :key="opt.value"
                :value="opt.value"
              >
                {{ opt.text }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Número de seguidores da plataforma principal</label>
            <input
              v-model="media.primary_platform_followers"
              type="number"
              min="0"
              class="form-control"
              @input="updateForm"
            >
          </div>
          <div class="form-group">
            <label>Plataforma secundária</label>
            <select
              v-model="media.secondary_platform"
              class="form-control"
              @change="updateForm"
            >
              <option :value="null">
                Selecione
              </option>
              <option
                v-for="opt in platformOptions"
                :key="opt.value"
                :value="opt.value"
              >
                {{ opt.text }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Número de seguidores da plataforma secundária</label>
            <input
              v-model="media.secondary_platform_followers"
              type="number"
              min="0"
              class="form-control"
              @input="updateForm"
            >
          </div>
          <div class="form-group">
            <label>Pessoa de contato</label>
            <input
              v-model="media.contact_person"
              type="text"
              class="form-control"
              @input="updateForm"
            >
          </div>
          <div class="form-group">
            <label>Email da pessoa de contato</label>
            <input
              v-model="media.contact_person_email"
              type="email"
              class="form-control"
              @input="updateForm"
            >
          </div>
          <div class="form-group">
            <label>WhatsApp da pessoa de contato</label>
            <input
              v-model="media.contact_person_whatsapp"
              type="text"
              class="form-control"
              @input="updateForm"
            >
          </div>
          <div class="form-group">
            <label>Tem um jornalista responsável?</label>
            <select
              v-model="media.has_responsible_journalist"
              class="form-control"
              @change="updateForm"
            >
              <option :value="null">
                Selecione
              </option>
              <option
                v-for="opt in yesNoOptions"
                :key="opt.value"
                :value="opt.value"
              >
                {{ opt.text }}
              </option>
            </select>
          </div>
          <div
            v-show="media.has_responsible_journalist === 1"
            class="form-group"
          >
            <label>Nome do jornalista responsável</label>
            <input
              v-model="media.responsible_journalist_name"
              type="text"
              class="form-control"
              @input="updateForm"
            >
          </div>
          <div class="form-group">
            <label>Já sofreu assédio judicial?</label>
            <select
              v-model="media.has_suffered_legal_harassment"
              class="form-control"
              @change="updateForm"
            >
              <option :value="null">
                Selecione
              </option>
              <option
                v-for="opt in yesNoOptions"
                :key="opt.value"
                :value="opt.value"
              >
                {{ opt.text }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Já teve o canal suspenso?</label>
            <select
              v-model="media.has_had_channel_suspended"
              class="form-control"
              @change="updateForm"
            >
              <option :value="null">
                Selecione
              </option>
              <option
                v-for="opt in yesNoOptions"
                :key="opt.value"
                :value="opt.value"
              >
                {{ opt.text }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Recebe repasses das plataformas?</label>
            <select
              v-model="media.receives_platform_transfers"
              class="form-control"
              @change="updateForm"
            >
              <option :value="null">
                Selecione
              </option>
              <option
                v-for="opt in yesNoOptions"
                :key="opt.value"
                :value="opt.value"
              >
                {{ opt.text }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Acessibilidade</label>
            <v-check-box-group
              v-model="media.accessibility_features"
              :options="accessibilityOptions"
              @input="updateForm"
            />
          </div>
          <div class="form-group">
            <label>Como descreve o canal?</label>
            <v-check-box-group
              v-model="media.channel_descriptions"
              :options="channelDescriptionOptions"
              @input="updateForm"
            />
          </div>
          <div class="form-group">
            <label>Dá acesso aos princípios editoriais?</label>
            <select
              v-model="media.has_editorial_principles"
              class="form-control"
              @change="updateForm"
            >
              <option :value="null">
                Selecione
              </option>
              <option
                v-for="opt in yesNoOptions"
                :key="opt.value"
                :value="opt.value"
              >
                {{ opt.text }}
              </option>
            </select>
          </div>
          <div
            v-show="media.has_editorial_principles === 1"
            class="form-group"
          >
            <label>Link para os princípios editoriais</label>
            <input
              v-model="media.editorial_principles_link"
              type="url"
              class="form-control"
              @input="updateForm"
            >
          </div>
          <div class="form-group">
            <label>Tipologia do conteúdo</label>
            <v-check-box-group
              v-model="media.content_typologies"
              :options="contentTypologyOptions"
              @input="updateForm"
            />
          </div>
        </div>
        <div class="form-group">
          <label>Este veículo é um meio de jornalismo?</label>
          <br>
          <small>Caso veículo seja um meio de jornalismo assinale SIM. Caso seja um veículo ligado a
            instituições públicas como Prefeituras e Estados ou organizações não jornalísticas (como
            sindicatos, associações e empresas não jornalísticas), assinale NÃO.</small>
          <select
            v-model="media.journalism"
            class="form-control"
            @change="updateForm"
          >
            <option
              v-for="opt in journalismChoices"
              :key="opt.value"
              :value="opt.value"
            >
              {{ opt.text }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label>Cidade-sede do veículo </label>
          <br>
          <small>Coloque apenas o nome da cidade do veículo (sem o Estado). Certifique-se de que o nome esteja
            escrito corretamente, porque erros de digitação podem anular, ou no mínimo dificultar, a
            validação de sua sugestão.</small>
          <v-auto-complete
            v-model="city"
            :options="cities"
            :service="cityService"
            :is-async="true"
            @input="updateForm"
          />
        </div>
        <div class="form-group">
          <label>Endereço</label>
          <br>
          <small>Por favor, forneça o logradouro onde o veículo tem sede, caso disponível</small>
          <input
            v-model="media.address"
            type="text"
            class="form-control"
            @input="updateForm"
          >
        </div>
        <div class="form-group">
          <label>Segmento PRINCIPAL do veículo de imprensa</label>
          <br>
          <small>Favor assinalar o PRINCIPAL. Ex. se um veículo é mais conhecido por seu jornal, mas também
            tem um site, assinale "Jornal". Se for exclusivamente digital, assinale "Online". Se for "blog"
            ou uma "revista online", assinale "Online" também, mas se houver versão impressa, assinale
            "Revista". Agências de notícia e newsletters são "Online". E assim vai...</small>
          <select
            v-model="media.segment_id"
            class="form-control"
            @change="updateForm"
          >
            <option
              v-for="opt in segments"
              :key="opt.value"
              :value="opt.value"
            >
              {{ opt.text }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label>Quais as características desse veículo, onde se destaca?</label>
          <br>
          <small>Pode marcar mais de uma alternativa</small>
          <v-check-box-group
            v-model="media.features"
            :options="features"
          />
        </div>
        <div class="form-group">
          <label>Modelo de negócios do veículo</label>
          <v-check-box-group
            v-model="media.businessModels"
            :options="businessModels"
          />
        </div>
        <div class="form-group">
          <label>Qual o tamanho do quadro de funcionários/colaboradores, incluindo jornalistas e profissionais
            de outras áreas?</label>
          <select
            v-model="media.employees_range_id"
            class="form-control"
            @change="updateForm"
          >
            <option
              v-for="opt in employeesRanges"
              :key="opt.value"
              :value="opt.value"
            >
              {{ opt.text }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label>Periodicidade: qual a frequência de publicação ou transmissão desse veículo</label>
          <br>
          <small>Ex. para boa parte das emissoras de televisão, a periodicidade é diária</small>
          <select
            v-model="media.periodicity"
            class="form-control"
            @change="updateForm"
          >
            <option
              v-for="opt in periodicities"
              :key="opt.value"
              :value="opt.value"
            >
              {{ opt.text }}
            </option>
          </select>
        </div>
        <div
          v-show="media.periodicity === 'another'"
          class="form-group"
        >
          <label>Qual a periodicidade?</label>
          <input
            v-model="media.another_periodicity"
            type="text"
            class="form-control"
            @input="updateForm"
          >
        </div>
        <div class="form-group">
          <label>Propriedade do veículo</label>
          <br>
          <small>Escreva aqui o nome do grupo econômico ou do proprietário do veículo, buscando sempre que
            possível indicando um link que prove isso. Ex. site da organização, processo judicial, WHOIS,
            etc</small>
          <v-auto-complete
            v-model="media.sponsor"
            :service="sponsorService"
            :is-async="true"
            @input="updateForm"
          />
        </div>
        <div class="form-group">
          <label>Email geral do veículo</label>
          <input
            v-model="media.email"
            type="text"
            class="form-control"
            @change="updateForm"
          >
        </div>
        <div class="form-group">
          <label>Observação/Notas</label>
          <br>
          <small>Escreva aqui qualquer observação que tenha. Ex. se seu veículo cobre outra cidade além de
            onde é sediado.</small>
          <textarea
            v-model="media.annotations"
            class="form-control"
            @change="updateForm"
          />
        </div>
        <div
          v-for="(channel,i) in channels"
          :key="i"
          class="form-group"
        >
          <label>Link para o {{ channel.text }} do Veículo</label>
          <br>
          <small>{{ channel.hint }}</small>
          <input
            v-if="media.mediaChannels.length > 0"
            v-model="media.mediaChannels[i].link"
            type="text"
            class="form-control"
            @input="updateChannel($event,i)"
          >
        </div>
        <div class="form-group">
          <label>Você é</label>
          <br>
          <small>Assinale uma das categorias abaixo que mais se enquadra com seu perfil. Esse campo é
            importante para nos ajudar na validação dos dados e entendermos o interesse da participação na
            pesquisa.
          </small>
          <select
            v-model="media.collaborator_id"
            class="form-control"
            @change="updateForm"
          >
            <option
              v-for="opt in collaborators"
              :key="opt.value"
              :value="opt.value"
            >
              {{ opt.text }}
            </option>
          </select>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import SegmentService from "../../admin/js/services/SegmentService";
import SponsorService from "../../admin/js/services/SponsorService";
import CityService from "../../admin/js/services/CityService";
import EmployeesRangeService from "../../admin/js/services/EmployeesRangeService";
import ChannelService from "../../admin/js/services/ChannelService";
import BusinessModelService from "../../admin/js/services/BusinessModelService";
import FeatureService from "../../admin/js/services/FeatureService";
import CollaboratorService from "../../admin/js/services/CollaboratorService";
import VCheckBoxGroup from "./VCheckBoxGroup";
import VAutoComplete from "./VAutoComplete";
import SuggestionService from "../../admin/js/services/SuggestionService";
import httpClient from "../infra/httpClient";

const platformNativeMediaDefaults = () => ({
  initiative_start_year: null,
  main_coverage_topic: null,
  other_coverage_topics: [],
  target_audiences: [],
  coverage_scopes: [],
  produces_original_content: null,
  primary_platform: null,
  primary_platform_followers: null,
  secondary_platform: null,
  secondary_platform_followers: null,
  contact_person: null,
  contact_person_email: null,
  contact_person_whatsapp: null,
  has_responsible_journalist: null,
  responsible_journalist_name: null,
  has_suffered_legal_harassment: null,
  has_had_channel_suspended: null,
  receives_platform_transfers: null,
  accessibility_features: [],
  channel_descriptions: [],
  has_editorial_principles: null,
  editorial_principles_link: null,
  content_typologies: []
});

const platformNativeFieldNames = Object.keys(platformNativeMediaDefaults());
const platformNativeBooleanFields = [
  "produces_original_content",
  "has_responsible_journalist",
  "has_suffered_legal_harassment",
  "has_had_channel_suspended",
  "receives_platform_transfers",
  "has_editorial_principles"
];
const normalizeBooleanOption = value => {
  if (value === null || value === undefined) {
    return null;
  }
  return Number(value) === 1 ? 1 : 0;
};

export default {
  components: {
    VAutoComplete,
    VCheckBoxGroup
  },
  data: () => ({
    media: Object.assign({
      media: null,
      segment_id: null,
      sponsor: null,
      city_id: null,
      address: null,
      annotations: null,
      email: null,
      employees_range_id: null,
      periodicity: null,
      another_periodicity: null,
      journalism: null,
      active: true,
      paid_site: null,
      mediaChannels: [],
      businessModels: [],
      features: [],
      collaborator_id: []
    }, platformNativeMediaDefaults()),
    city: null,
    cityQuery: "",
    segments: null,
    cities: [],
    employeesRanges: null,
    periodicities: [
      {
        value: "continuous",
        text: "Atualização Contínua"
      },
      {
        value: "daily",
        text: "Diário"
      },
      {
        value: "biweekly",
        text: "Bisemanal"
      },
      {
        value: "triweekly",
        text: "Trisemanal"
      },
      {
        value: "monfri",
        text: "Segunda à Sexta"
      },
      {
        value: "monsat",
        text: "Segunda à Sábado"
      },
      {
        value: "weekly",
        text: "Semanal"
      },
      {
        value: "fortnightly",
        text: "Quinzenal"
      },
      {
        value: "monthly",
        text: "Mensal"
      },
      {
        value: "bimonthly",
        text: "Bimestral"
      },
      {
        value: "trimonthly",
        text: "Trimestral"
      },
      {
        value: "undefined",
        text: "Sem periodicidade definida"
      },
      {
        value: "another",
        text: "Outro"
      }
    ],
    journalismChoices: [
      {
        value: 1,
        text: "Sim"
      },
      {
        value: 0,
        text: "Não"
      }
    ],
    paidSiteOptions: [
      {
        value: null,
        text: "Não tenho certeza"
      },
      {
        value: 1,
        text: "Sim"
      },
      {
        value: 0,
        text: "Não"
      }
    ],
    yesNoOptions: [
      {
        value: 1,
        text: "Sim"
      },
      {
        value: 0,
        text: "Não"
      }
    ],
    coverageTopics: [
      "Política",
      "Economia e Finanças",
      "Esporte",
      "Ciência",
      "Saúde",
      "Polícia e Segurança",
      "Educação",
      "Tecnologia",
      "Arte e Cultura",
      "Mundo",
      "Celebridades",
      "Moda",
      "Gastronomia",
      "Agronegócio",
      "Cidade",
      "Turismo",
      "Carros e Motores",
      "Gênero",
      "Raça",
      "Direitos Humanos",
      "Diversão"
    ].map(text => ({ value: text, text })),
    targetAudiences: [
      "Crianças e adolescentes",
      "Jovens",
      "Adultos",
      "Mulheres",
      "LGBTQIA+",
      "Homens",
      "Idosos",
      "Pessoas com deficiência"
    ].map(text => ({ value: text, text })),
    coverageScopes: ["Local", "Regional", "Nacional", "Internacional"].map(text => ({ value: text, text })),
    platformOptions: [
      "X",
      "Facebook",
      "Instagram",
      "YouTube",
      "Threads",
      "Linkedin",
      "TikTok",
      "Telegram",
      "WhatsApp",
      "Discord",
      "Spotify",
      "Substack",
      "Outro"
    ].map(text => ({ value: text, text })),
    accessibilityOptions: [
      "Legendas",
      "Tradução",
      "Aumento da fonte",
      "Libras",
      "Vídeo descrição"
    ].map(text => ({ value: text, text })),
    channelDescriptionOptions: [
      "Podcast",
      "Videocast",
      "Newsletter",
      "Perfil em rede social",
      "Página em rede social",
      "Canal de vídeo em rede social",
      "Canal em aplicativo de mensagens"
    ].map(text => ({ value: text, text })),
    contentTypologyOptions: [
      "Reportagens investigativas",
      "Análises",
      "Hard news",
      "Soft news",
      "Comentários",
      "Curadoria"
    ].map(text => ({ value: text, text })),
    businessModels: [],
    features: [],
    collaborators: null,
    channels: null,
    suggestionService: new SuggestionService("/api/v1/", httpClient),
    segmentService: new SegmentService("/api/v1/", httpClient),
    sponsorService: new SponsorService("/api/v1/", httpClient),
    cityService: new CityService("/api/v1/", httpClient),
    employeesRangeService: new EmployeesRangeService("/api/v1/", httpClient),
    channelService: new ChannelService("/api/v1/", httpClient),
    businessModelService: new BusinessModelService("/api/v1/", httpClient),
    featureService: new FeatureService("/api/v1/", httpClient),
    collaboratorService: new CollaboratorService("/api/v1/", httpClient)
  }),
  watch: {
    regionId(value) {
      this.filteredStates = this.states.filter(s => s.region_id === value);
    },
    city(value) {
      this.media.city_id = null;
      if (value) {
        this.media.city_id = value.value;
      }
    }
  },
  async beforeMount() {
    this.enableLoadingState();
    const calls = [
      this.segmentService.all().then(d => (this.segments = d)),
      this.employeesRangeService.all().then(d => (this.employeesRanges = d)),
      this.channelService.all().then(d => {
        this.channels = d;
        this.media.mediaChannels = this.channels.map(c => ({
          channel_id: c.value,
          link: null
        }));
      }),
      this.businessModelService.all().then(d => (this.businessModels = d)),
      this.featureService.all().then(d => (this.features = d)),
      this.collaboratorService.all().then(d => (this.collaborators = d))
    ];
    await Promise.all(calls);
    this.disableLoadingState();
  },
  methods: {
    updateForm() {
      this.$emit("input", this.media);
    },
    updatePaidSite() {
      if (this.media.paid_site !== 1) {
        this.clearPlatformNativeFields();
      }
      this.updateForm();
    },
    clearPlatformNativeFields() {
      const defaults = platformNativeMediaDefaults();
      platformNativeFieldNames.forEach(field => {
        this.media[field] = defaults[field];
      });
    },
    async fetchCities() {
      this.cities = await this.cityService.all(this.stateId);
    },
    async getMediaData(id) {
      const mediaData = this.media.media;
      if (!id) {
        let channels = [];
        if (this.channels) {
          channels = this.channels.map(c => ({
            channel_id: c.value,
            link: null
          }));
        }
        this.city = null;
        this.media = Object.assign({
          media: mediaData,
          segment_id: null,
          sponsor: {
            value: null,
            text: null
          },
          city_id: null,
          address: null,
          annotations: null,
          email: null,
          employees_range_id: null,
          periodicity: null,
          another_periodicity: null,
          journalism: null,
          active: true,
          paid_site: null,
          mediaChannels: channels,
          businessModels: [],
          features: [],
          collaborator_id: []
        }, platformNativeMediaDefaults());
        this.updateForm();
        return;
      }
      const media = await this.suggestionService.get(id, "suggestion");

      this.city = {
        text: media.city ? media.city.name : null,
        value: media.city ? parseInt(media.city.id) : null
      };
      const platformNativeData = platformNativeFieldNames.reduce((data, field) => {
        if (media[field] === null || media[field] === undefined) {
          data[field] = platformNativeMediaDefaults()[field];
        } else if (platformNativeBooleanFields.indexOf(field) >= 0) {
          data[field] = normalizeBooleanOption(media[field]);
        } else {
          data[field] = media[field];
        }
        return data;
      }, {});

      this.media = Object.assign({
        media: {
          text: media.name,
          value: media.id
        },
        segment_id: media.segment_id,
        sponsor: {
          value: media.sponsor ? media.sponsor.id : null,
          text: media.sponsor ? media.sponsor.name : null
        },
        address: media.address,
        annotations: media.annotations,
        email: media.email,
        employees_range_id: media.employees_range_id,
        periodicity: media.periodicity,
        another_periodicity: media.another_periodicity,
        journalism: media.journalism,
        paid_site: normalizeBooleanOption(media.paid_site),
        mediaChannels: this.media.mediaChannels.map(c => {
          const index = media.media_channels
            .map(m => m.channel_id)
            .indexOf(c.channel_id);
          if (index >= 0) {
            c.link = media.media_channels[index].link;
          }
          return c;
        }),
        businessModels: media.business_models.map(b => b.id),
        features: media.features.map(f => f.id),
        collaborator_id: media.collaborator_id
      }, platformNativeData);
      this.updateForm();
    },
    updateChannel(event, index) {
      const { value } = event.target;
      this.media.mediaChannels[index].link = null;
      if (value.length > 0) {
        this.media.mediaChannels[index].link = event.target.value;
      }
      this.updateForm();
    },
    enableLoadingState() {
      this.$emit("startAjax");
    },
    disableLoadingState() {
      this.$emit("endAjax");
    }
  }
};
</script>

<style scoped>

</style>
